module.exports = __webpack_public_path__ + "media/images/gallery/order_on-be95f7f411aa9dc22aa04e3948983ff8.gif";